// store/page/material/materialSlice.js
import { createSlice } from '@reduxjs/toolkit';

import {
  addUfDimesionParams,
  fetchUfDimensionallyObsParams,
  fetchUfVisualObsParams,
  fetchUfComponentNames,
  fetchUfMachineNames,
  fetchOperationNames,
  addOperationName,
  fetchUfFrameTypes,
  addUfFrameType,
  addDrgNumber,
  fetchDrgNumbers,
  fetchInstruments,
  fetchRoofDimensionalObsParams,
  getRoofDimensionalObsParamsById,
  addRoofDimensionalObsParams,
  // updateRoofDimensionalObsParams,
  deleteRoofDimensionalObsParams,
  getmasterOperationName,
  fetchUfCrossMemberParams,
  getUfDimensionObsById,
  // updateUfDimensionObs,
  deleteUfDimensionObs,
  addTrainType,
  fetchUfTrainTypes,
  deleteTrainType,
  deleteMachineName,
  deleteInstrument,
  deleteComponentName,
  deleteUfCrossMember,
  fetchAllMakes,
  fetchAllMasterDrgNos,
  fetchShiftTypes,
  // updateTrainType,
  fetchUfFrameNumber,
  fetchDrawingNumbers,
  AllbingingDrgNos,
  fetchRoofDrgNumbers,
  fetchAllMasterNumbers,
  storeDailyOutTurnReport,
  fetchDailyOutTurnList,
  // fetchAllbingingDrgNos,
  fetchBufferCbcObsParams,
  getBufferCbcParamsById,
  fetchShellNumbersForFinal,
  listCrPosition,
  DailyDispatchList,
  StoreDailyDispatchReport,
  listBacklog,
  getStageNumbers,
  getStaticLoadDefectTest,
  getListDefectManagement,
  listCrPositionDetails,
  storeCrPositionDetails,
  getShopsList,
  getFormStageList,
  fetchVersion,
  fetchShellNumbersForFilter,
  fetchNotifications,
  fetchSingleNotification,
} from './materialThunk';

import { addUfVisualObs } from '../frametype/frametypeThunk';

const initialState = {
  bind_drg: [],
  master_operations_name: [],
  materials: [],
  uf_visual_params: [],
  uf_component_names: [],
  uf_machine_names: [],
  operationNames: [],
  uf_frame_types: [],
  drg_numbers: [],
  roof_drg_numbers: [],
  drg_nos: [],
  under_frame_no: [],
  instruments: [],
  crossMemberParams: [],
  shell_numbers: [],
  addDrg: {
    loading: false,
    success: false,
    error: null,
  },
  loading: false,
  error: null,
  successMessage: null,
  addOperation: {
    loading: false,
    success: false,
    error: null,
  },
  roofDimensionObs: [],
  loadingRoofDimension: false,
  roofDimensionDetail: null,
  addRoofDimension: {
    loading: false,
    success: false,
    error: null,
  },
  updateRoofDimension: {
    loading: false,
    success: false,
    error: null,
  },
  deleteRoofDimension: {
    loading: false,
    success: false,
    error: null,
  },
  loadingTrainTypes: false,
  train_types: [],
  ufDimensionDetail: null,

  updateUfDimension: {
    loading: false,
    success: false,
    error: null,
  },

  deleteUfDimension: {
    loading: false,
    success: false,
    error: null,
  },

  shift_types: [],
  all_makes: [],
  master_drg_nos: [],
  pagination: null,
  dailyOutTurn: {
    report: null,
    list: [],
    summary: null,
    pagination: null,
  },
  dailyOutTurnLoading: false,
  dailyOutTurnError: null,
  bufferDimensionObs: [],
  loadingBufferCbcDimension: false,
  loadingBufferDimension: false,
  bufferDimensionDetail: null,
  getListCrPosition: {
    loading: false,
    success: false,
    error: null,
  },

  dailyDispatchList: {
    loading: false,
    success: false,
    error: null,
    data: [],
  },

  storeDailyDispatch: {
    loading: false,
    success: false,
    error: null,
    data: [],
  },

  listCrPositionData: [],
  listCrPositionTotal: 0,
  listCrPositionCurrentPage: 1,
  listCrPositionPerPage: 10,

  getListBacklog: {
    loading: false,
    success: false,
    error: null,
  },
  stageNumbers: {
    loading: false,
    success: false,
    error: null,
    data: [],
  },

  getListDefectMngmnt: {
    loading: false,
    success: false,
    error: null,
    data: [],
  },

  getStaticLoadDft: {
    loading: false,
    success: false,
    error: null,
    data: [],
  },

  crPositionDetailsList: {
    loading: false,
    success: false,
    error: null,
    data: [],
  },

  storeCrPositionDetails: {
    loading: false,
    success: false,
    error: null,
    data: [],
  },
  shops_list: {
    loading: false,
    success: false,
    error: null,
    data: [],
  },
  form_stage_list: {
    loading: false,
    success: false,
    error: null,
    data: [],
  },
  versionList: {
    loading: false,
    success: false,
    error: null,
    data: null,
  },
  allShellNo: {
    loading: false,
    success: false,
    error: null,
    data: null,
  },
  notificationData: {
    loading: false,
    success: false,
    error: null,
    data: null,
  },
  selectedNotification: {
    loading: false,
    success: false,
    error: null,
    data: null,
  },
};

const materialSlice = createSlice({
  name: 'material',
  initialState,
  reducers: {
    clearMaterialError: (state) => {
      state.error = null;
    },
    clearDrgMessages: (state) => {
      state.drg_numbers = [];
      state.error = null;
    },
    clearDrgNoMessages: (state) => {
      state.drg_nos = [];
      state.error = null;
    },
    clearframeNumberMessages: (state) => {
      state.under_frame_no = [];
      state.error = null;
    },
    clearAddDrgState: (state) => {
      state.addDrg = {
        loading: false,
        success: false,
        error: null,
      };
    },
    clearComponentMessages: (state) => {
      state.uf_component_names = [];
      state.error = null;
    },
    clearAddOperationState: (state) => {
      state.addOperation = {
        loading: false,
        success: false,
        error: null,
      };
    },
    clearSuccessMessage: (state) => {
      state.successMessage = null;
    },
    clearRoofDimensionDetail: (state) => {
      state.roofDimensionDetail = null;
    },
    clearAddRoofDimensionState: (state) => {
      state.addRoofDimension = {
        loading: false,
        success: false,
        error: null,
      };
    },
    clearUpdateRoofDimensionState: (state) => {
      state.updateRoofDimension = {
        loading: false,
        success: false,
        error: null,
      };
    },
    clearDeleteRoofDimensionState: (state) => {
      state.deleteRoofDimension = {
        loading: false,
        success: false,
        error: null,
      };
    },
    resetRoofDimensionStates: (state) => {
      state.addRoofDimension = {
        loading: false,
        success: false,
        error: null,
      };
      state.updateRoofDimension = {
        loading: false,
        success: false,
        error: null,
      };
      state.deleteRoofDimension = {
        loading: false,
        success: false,
        error: null,
      };
      state.roofDimensionDetail = null;
      state.error = null;
    },
    clearSelected: (state) => {
      state.selectedNotification.data = null;
    },
  },
  extraReducers: (builder) => {
    builder

      .addCase(DailyDispatchList.pending, (state) => {
        state.dailyDispatchList.loading = true;
        state.dailyDispatchList.error = null;
        state.dailyDispatchList.success = false;
      })
      .addCase(DailyDispatchList.fulfilled, (state, action) => {
        state.dailyDispatchList.loading = false;
        state.dailyDispatchList.success = true;
        state.dailyDispatchList.data = action.payload;
        state.dailyDispatchList.error = null;
      })
      .addCase(DailyDispatchList.rejected, (state, action) => {
        state.dailyDispatchList.loading = false;
        state.dailyDispatchList.success = false;
        state.dailyDispatchList.error = action.payload || 'Failed to fetch daily dispatch list';
        state.dailyDispatchList.data = [];
      })

      // ============================================
      // STORE DAILY DISPATCH REPORT REDUCERS
      // ============================================
      .addCase(StoreDailyDispatchReport.pending, (state) => {
        state.storeDailyDispatch.loading = true;
        state.storeDailyDispatch.error = null;
        state.storeDailyDispatch.success = false;
      })
      .addCase(StoreDailyDispatchReport.fulfilled, (state, action) => {
        state.storeDailyDispatch.loading = false;
        state.storeDailyDispatch.success = true;
        state.storeDailyDispatch.data = action.payload;
        state.storeDailyDispatch.error = null;
      })
      .addCase(StoreDailyDispatchReport.rejected, (state, action) => {
        state.storeDailyDispatch.loading = false;
        state.storeDailyDispatch.success = false;
        state.storeDailyDispatch.error = action.payload || 'Failed to save daily dispatch report';
        state.storeDailyDispatch.data = [];
      })

      // Fetch under frame stage -I dimensional observations
      .addCase(fetchUfDimensionallyObsParams.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchUfDimensionallyObsParams.fulfilled, (state, action) => {
        state.loading = false;
        state.materials = action.payload.data.data;
        state.pagination = {
          total: action.payload.data.total,
          per_page: action.payload.data.per_page,
          current_page: action.payload.data.current_page,
          last_page: action.payload.data.last_page,
        };
      })
      .addCase(fetchUfDimensionallyObsParams.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || 'Failed to fetch materials';
      })

      .addCase(AllbingingDrgNos.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(AllbingingDrgNos.fulfilled, (state, action) => {
        state.loading = false;
        state.bind_drg = action.payload.data;
      })
      .addCase(AllbingingDrgNos.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Fetch under frame stage -I visual params
      .addCase(fetchUfVisualObsParams.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchUfVisualObsParams.fulfilled, (state, action) => {
        state.loading = false;

        state.uf_visual_params = action.payload?.data || [];

        state.pagination = {
          currentPage: action.payload?.current_page || 1,
          totalPages: action.payload?.total_pages || 1,
          totalItems: action.payload?.total || 0,
          perPage: action.payload?.per_page || 10,
        };
      })
      .addCase(fetchUfVisualObsParams.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || 'Failed to fetch materials';
      })
      // Fetch under frame component names
      .addCase(fetchUfComponentNames.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchUfComponentNames.fulfilled, (state, action) => {
        state.loading = false;
        state.uf_component_names = action.payload.data;
      })
      .addCase(fetchUfComponentNames.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || 'Failed to fetch component names';
      })
      // Add material
      .addCase(addUfDimesionParams.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(addUfDimesionParams.fulfilled, (state) => {
        // Removed unused 'action' parameter
        state.loading = false;
        state.successMessage = 'Material added successfully';
      })
      .addCase(addUfDimesionParams.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || 'Failed to add material';
      })

      .addCase(addUfVisualObs.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(addUfVisualObs.fulfilled, (state) => {
        state.loading = false;
        state.successMessage = 'Visual obs saved successfully';
      })
      .addCase(addUfVisualObs.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || 'Failed to add cross member parameters';
      })

      // Fetch operation names
      .addCase(fetchOperationNames.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchOperationNames.fulfilled, (state, action) => {
        state.loading = false;
        state.operationNames = action.payload?.data || action.payload || [];
      })
      .addCase(fetchOperationNames.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || 'Failed to fetch operation names';
      })

      // Add operation name
      .addCase(addOperationName.pending, (state) => {
        state.addOperation.loading = true;
        state.addOperation.success = false;
        state.addOperation.error = null;
        state.error = null;
      })
      .addCase(addOperationName.fulfilled, (state, action) => {
        state.addOperation.loading = false;
        state.addOperation.success = true;
        state.successMessage = action.payload?.message || 'Operation name added successfully';

        // Optionally add the new operation to the operationNames list
        if (action.payload?.data) {
          state.operationNames = [...(state.operationNames || []), action.payload.data];
        }
      })
      .addCase(addOperationName.rejected, (state, action) => {
        state.addOperation.loading = false;
        state.addOperation.success = false;
        state.addOperation.error = action.payload || 'Failed to add operation name';
        state.error = action.payload || 'Failed to add operation name';
      })
      .addCase(fetchDrgNumbers.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchDrgNumbers.fulfilled, (state, action) => {
        state.loading = false;
        state.drg_numbers = action.payload.data;
      })
      .addCase(fetchDrgNumbers.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || 'Failed to fetch Drg numbers';
      })

      .addCase(fetchRoofDrgNumbers.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchRoofDrgNumbers.fulfilled, (state, action) => {
        state.loading = false;
        state.roof_drg_numbers = action.payload.data;
      })
      .addCase(fetchRoofDrgNumbers.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || 'Failed to fetch Roof Drg numbers';
      })
      .addCase(fetchDrawingNumbers.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchDrawingNumbers.fulfilled, (state, action) => {
        state.loading = false;
        state.drg_nos = action.payload.data;
      })
      .addCase(fetchDrawingNumbers.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || 'Failed to fetch Drawing numbers';
      })

      .addCase(fetchUfFrameNumber.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchUfFrameNumber.fulfilled, (state, action) => {
        state.loading = false;
        state.under_frame_no = action.payload.data;
      })
      .addCase(fetchUfFrameNumber.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || 'Failed to fetch under frame numbers';
      })

      // Add Drg Number
      .addCase(addDrgNumber.pending, (state) => {
        state.addDrg.loading = true;
        state.addDrg.success = false;
        state.addDrg.error = null;
        state.error = null;
      })
      .addCase(addDrgNumber.fulfilled, (state, action) => {
        state.addDrg.loading = false;
        state.addDrg.success = true;
        state.successMessage = action.payload?.message || 'Drg number added successfully';
      })
      .addCase(addDrgNumber.rejected, (state, action) => {
        state.addDrg.loading = false;
        state.addDrg.success = false;
        state.addDrg.error = action.payload || 'Failed to add Drg number';
        state.error = action.payload || 'Failed to add Drg number';
      })
      .addCase(fetchUfFrameTypes.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchUfFrameTypes.fulfilled, (state, action) => {
        state.loading = false;
        state.uf_frame_types = action.payload?.data || action.payload || [];
      })
      .addCase(fetchUfFrameTypes.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || 'Failed to fetch frame types';
      })
      .addCase(addUfFrameType.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(addUfFrameType.fulfilled, (state, action) => {
        state.loading = false;
        state.successMessage = action.payload?.message || 'Frame type added successfully';
      })
      .addCase(addUfFrameType.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || 'Failed to add frame type';
      })
      .addCase(fetchUfMachineNames.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchUfMachineNames.fulfilled, (state, action) => {
        state.loading = false;
        state.uf_machine_names = action.payload.data;
      })
      .addCase(fetchUfMachineNames.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || 'Failed to fetch Drg numbers';
      })
      .addCase(fetchInstruments.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchInstruments.fulfilled, (state, action) => {
        state.loading = false;
        state.instruments = action.payload.data;
      })
      .addCase(fetchInstruments.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || 'Failed to fetch instruments';
      })
      .addCase(getmasterOperationName.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getmasterOperationName.fulfilled, (state, action) => {
        state.loading = false;
        state.master_operations_name = action.payload.data;
      })
      .addCase(getmasterOperationName.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || 'Failed to fetch component names';
      })

      // ============================================
      // ROOF DIMENSION OBS REDUCERS

      .addCase(fetchRoofDimensionalObsParams.pending, (state) => {
        state.loadingRoofDimension = true;
        state.error = null;
      })
      .addCase(fetchRoofDimensionalObsParams.fulfilled, (state, action) => {
        state.loadingRoofDimension = false;
        state.roofDimensionObs = action.payload?.data || [];
        state.successMessage = action.payload?.message || 'Roof observations fetched successfully';
      })
      .addCase(fetchRoofDimensionalObsParams.rejected, (state, action) => {
        state.loadingRoofDimension = false;
        state.roofDimensionObs = [];
        state.error = action.payload || 'Failed to fetch roof observations';
      })

      // Get Roof Dimension Obs by ID
      .addCase(getRoofDimensionalObsParamsById.pending, (state) => {
        state.loadingRoofDimension = true;
        state.error = null;
      })
      .addCase(getRoofDimensionalObsParamsById.fulfilled, (state, action) => {
        console.log('Roof Dimension Detail Payload addCase:', action.payload);
        console.log('Roof Dimension Data addCase:', action.payload);
        state.loadingRoofDimension = false;
        state.roofDimensionDetail = action.payload || null;
      })
      .addCase(getRoofDimensionalObsParamsById.rejected, (state, action) => {
        state.loadingRoofDimension = false;
        state.roofDimensionDetail = null;
        state.error = action.payload || 'Failed to fetch roof observation details';
      })

      // Add Roof Dimension Obs
      .addCase(addRoofDimensionalObsParams.pending, (state) => {
        state.addRoofDimension.loading = true;
        state.addRoofDimension.success = false;
        state.addRoofDimension.error = null;
        state.error = null;
      })
      .addCase(addRoofDimensionalObsParams.fulfilled, (state, action) => {
        state.addRoofDimension.loading = false;
        state.addRoofDimension.success = true;
        state.successMessage = action.payload?.message || 'Roof observation added successfully';

        if (action.payload?.data) {
          state.roofDimensionObs = [...state.roofDimensionObs, action.payload.data];
        }
      })
      .addCase(addRoofDimensionalObsParams.rejected, (state, action) => {
        state.addRoofDimension.loading = false;
        state.addRoofDimension.success = false;
        state.addRoofDimension.error = action.payload || 'Failed to add roof observation';
        state.error = action.payload || 'Failed to add roof observation';
      })

      // Update Roof Dimension Obs
      // .addCase(updateRoofDimensionalObsParams.pending, (state) => {
      //   state.updateRoofDimension.loading = true;
      //   state.updateRoofDimension.success = false;
      //   state.updateRoofDimension.error = null;
      //   state.error = null;
      // })
      // .addCase(updateRoofDimensionalObsParams.fulfilled, (state, action) => {
      //   state.updateRoofDimension.loading = false;
      //   state.updateRoofDimension.success = true;
      //   state.successMessage = action.payload?.message || 'Roof observation updated successfully';

      //   const updatedItem = action.payload?.data;

      //   if (updatedItem) {
      //     state.roofDimensionObs = state.roofDimensionObs.map((item) =>
      //       item._id === updatedItem._id ? updatedItem : item,
      //     );
      //   }
      // })
      // .addCase(updateRoofDimensionalObsParams.rejected, (state, action) => {
      //   state.updateRoofDimension.loading = false;
      //   state.updateRoofDimension.success = false;
      //   state.updateRoofDimension.error = action.payload || 'Failed to update roof observation';
      //   state.error = action.payload || 'Failed to update roof observation';
      // })

      // Delete Roof Dimension Obs
      .addCase(deleteRoofDimensionalObsParams.pending, (state) => {
        state.deleteRoofDimension.loading = true;
        state.deleteRoofDimension.success = false;
        state.deleteRoofDimension.error = null;
        state.error = null;
      })

      .addCase(deleteRoofDimensionalObsParams.fulfilled, (state, action) => {
        state.deleteRoofDimension.loading = false;
        state.deleteRoofDimension.success = true;

        state.successMessage = action.payload?.message || 'Roof observation deleted successfully';

        const deletedId = action.meta.arg;

        state.roofDimensionObs = state.roofDimensionObs.filter(
          (item) => String(item._id) !== String(deletedId),
        );
      })

      .addCase(deleteRoofDimensionalObsParams.rejected, (state, action) => {
        state.deleteRoofDimension.loading = false;
        state.deleteRoofDimension.success = false;

        state.deleteRoofDimension.error = action.payload || 'Failed to delete roof observation';

        state.error = action.payload || 'Failed to delete roof observation';
      })
      .addCase(fetchUfCrossMemberParams.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchUfCrossMemberParams.fulfilled, (state, action) => {
        state.loading = false;
        state.crossMemberParams = action.payload.data;
      })
      .addCase(fetchUfCrossMemberParams.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || 'Failed to fetch cross member params';
      })
      // ===============================
      // GET UF DIMENSION OBS BY ID

      .addCase(getUfDimensionObsById.pending, (state) => {
        state.loading = true;
        state.error = null;
      })

      .addCase(getUfDimensionObsById.fulfilled, (state, action) => {
        state.loading = false;
        state.ufDimensionDetail = action.payload?.data || null;
      })

      .addCase(getUfDimensionObsById.rejected, (state, action) => {
        state.loading = false;
        state.ufDimensionDetail = null;
        state.error = action.payload || 'Failed to fetch observation details';
      })

      // ===============================
      // UPDATE UF DIMENSION OBS

      // .addCase(updateUfDimensionObs.pending, (state) => {
      //   state.updateUfDimension.loading = true;
      //   state.updateUfDimension.success = false;
      //   state.updateUfDimension.error = null;
      // })

      // .addCase(updateUfDimensionObs.fulfilled, (state, action) => {
      //   state.updateUfDimension.loading = false;
      //   state.updateUfDimension.success = true;

      //   const updatedItem = action.payload?.data;

      //   if (updatedItem) {
      //     state.materials = state.materials.map((item) =>
      //       item._id === updatedItem._id ? updatedItem : item,
      //     );
      //   }
      // })

      // .addCase(updateUfDimensionObs.rejected, (state, action) => {
      //   state.updateUfDimension.loading = false;
      //   state.updateUfDimension.success = false;
      //   state.updateUfDimension.error = action.payload || 'Failed to update observation';
      // })

      // ===============================
      // DELETE UF DIMENSION OBS

      .addCase(deleteUfDimensionObs.pending, (state) => {
        state.deleteUfDimension.loading = true;
        state.deleteUfDimension.success = false;
        state.deleteUfDimension.error = null;
      })

      .addCase(deleteUfDimensionObs.fulfilled, (state, action) => {
        state.deleteUfDimension.loading = false;
        state.deleteUfDimension.success = true;

        const deletedId = action.meta.arg;

        state.materials = state.materials.filter((item) => item._id !== deletedId);
      })

      .addCase(deleteUfDimensionObs.rejected, (state, action) => {
        state.deleteUfDimension.loading = false;
        state.deleteUfDimension.success = false;
        state.deleteUfDimension.error = action.payload || 'Failed to delete observation';
      })
      .addCase(fetchUfTrainTypes.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchUfTrainTypes.fulfilled, (state, action) => {
        state.loading = false;
        state.train_types = action.payload.data;
      })
      .addCase(fetchUfTrainTypes.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || 'Failed to fetch train types';
      })
      .addCase(addTrainType.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(addTrainType.fulfilled, (state) => {
        state.loading = false;
        state.successMessage = 'Train type added successfully';
      })
      .addCase(addTrainType.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || 'Failed to add train type';
      })
      .addCase(deleteTrainType.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteTrainType.fulfilled, (state) => {
        state.loading = false;
        state.successMessage = 'Train type deleted successfully';
      })
      .addCase(deleteTrainType.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || 'Failed to delete train type';
      })
      .addCase(deleteMachineName.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteMachineName.fulfilled, (state) => {
        state.loading = false;
        state.successMessage = 'Machine name deleted successfully';
      })
      .addCase(deleteMachineName.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || 'Failed to delete machine name';
      })
      .addCase(deleteInstrument.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteInstrument.fulfilled, (state) => {
        state.loading = false;
        state.successMessage = 'Instrument deleted successfully';
      })
      .addCase(deleteInstrument.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || 'Failed to delete instrument';
      })
      .addCase(deleteComponentName.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteComponentName.fulfilled, (state) => {
        state.loading = false;
        state.successMessage = 'Component name deleted successfully';
      })
      .addCase(deleteComponentName.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || 'Failed to delete component name';
      })
      .addCase(deleteUfCrossMember.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteUfCrossMember.fulfilled, (state) => {
        state.loading = false;
        state.successMessage = 'Cross member deleted successfully';
      })
      .addCase(deleteUfCrossMember.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || 'Failed to delete cross member';
      })
      .addCase(fetchAllMakes.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAllMakes.fulfilled, (state, action) => {
        state.loading = false;
        state.all_makes = action.payload.data;
      })
      .addCase(fetchAllMakes.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || 'Failed to fetch train types';
      })
      // Fetch master drg nos
      .addCase(fetchAllMasterDrgNos.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAllMasterDrgNos.fulfilled, (state, action) => {
        state.loading = false;
        state.master_drg_nos = action.payload.data;
      })
      .addCase(fetchAllMasterDrgNos.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || 'Failed to fetch component names';
      })
      // Fetch shift types
      .addCase(fetchShiftTypes.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchShiftTypes.fulfilled, (state, action) => {
        state.loading = false;
        state.shift_types = action.payload.data;
      })
      .addCase(fetchShiftTypes.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || 'Failed to fetch shift types';
      })
      .addCase(fetchAllMasterNumbers.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAllMasterNumbers.fulfilled, (state, action) => {
        state.loading = false;
        state.numbers = action.payload.data;
      })
      .addCase(fetchAllMasterNumbers.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || 'Failed to fetch shift types';
      })
      .addCase(storeDailyOutTurnReport.pending, (state) => {
        state.dailyOutTurnLoading = true;
        state.dailyOutTurnError = null;
      })
      .addCase(storeDailyOutTurnReport.fulfilled, (state, action) => {
        state.dailyOutTurnLoading = false;
        state.dailyOutTurn.report = action.payload?.data;
        state.successMessage = action.payload?.message || 'Report saved successfully';
      })
      .addCase(storeDailyOutTurnReport.rejected, (state, action) => {
        state.dailyOutTurnLoading = false;
        state.dailyOutTurnError = action.payload;
        state.error = action.payload;
      })
      .addCase(fetchDailyOutTurnList.pending, (state) => {
        state.dailyOutTurnLoading = true;
        state.dailyOutTurnError = null;
      })
      .addCase(fetchDailyOutTurnList.fulfilled, (state, action) => {
        state.dailyOutTurnLoading = false;
        state.dailyOutTurn.list = action.payload?.data || [];
        state.dailyOutTurn.pagination = {
          current_page: action.payload?.current_page || 1,
          per_page: action.payload?.per_page || 10,
          total: action.payload?.total || 0,
          total_pages: action.payload?.total_pages || 1,
        };
      })
      .addCase(fetchDailyOutTurnList.rejected, (state, action) => {
        state.dailyOutTurnLoading = false;
        state.dailyOutTurnError = action.payload;
      })
      .addCase(fetchBufferCbcObsParams.pending, (state) => {
        state.loadingBufferCbcDimension = true;
        state.error = null;
      })
      .addCase(fetchBufferCbcObsParams.fulfilled, (state, action) => {
        state.loadingBufferCbcDimension = false;
        state.bufferDimensionObs = action.payload?.data || [];
        state.successMessage = action.payload?.message || 'Buffer CBC fetched successfully';
      })
      .addCase(fetchBufferCbcObsParams.rejected, (state, action) => {
        state.loadingBufferCbcDimension = false;
        state.bufferDimensionObs = [];
        state.error = action.payload || 'Failed to fetch buffer cbc observations';
      })
      .addCase(getBufferCbcParamsById.pending, (state) => {
        state.loadingBufferDimension = true;
        state.error = null;
      })
      .addCase(getBufferCbcParamsById.fulfilled, (state, action) => {
        state.loadingBufferDimension = false;
        state.bufferDimensionDetail = action.payload || null;
      })
      .addCase(getBufferCbcParamsById.rejected, (state, action) => {
        state.loadingBufferDimension = false;
        state.bufferDimensionDetail = null;
        state.error = action.payload || 'Failed to fetch roof observation details';
      })
      .addCase(fetchShellNumbersForFinal.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchShellNumbersForFinal.fulfilled, (state, action) => {
        state.loading = false;
        state.shell_numbers = action.payload.data;
      })
      .addCase(fetchShellNumbersForFinal.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || 'Failed to fetch shell numbers';
      })

      .addCase(listCrPosition.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(listCrPosition.fulfilled, (state, action) => {
        state.loading = false;
        state.getListCrPosition = action.payload.data || [];
        state.listCrPositionData = action.payload.data || [];
        state.listCrPositionTotal = action.payload.total || 0;
        state.listCrPositionCurrentPage = action.payload.current_page || 1;
        state.listCrPositionPerPage = action.payload.per_page || 10;
      })
      .addCase(listCrPosition.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || 'Failed to fetch list';
      })

      .addCase(listBacklog.pending, (state) => {
        state.getListBacklog = {
          loading: true,
          success: false,
          error: null,
          list: [],
          pagination: {
            current_page: 1,
            per_page: 10,
            total: 0,
            total_pages: 1,
          },
        };
      })
      .addCase(listBacklog.fulfilled, (state, action) => {
        state.getListBacklog = {
          loading: false,
          success: true,
          error: null,
          list: action.payload?.data || [],
          pagination: {
            current_page: action.payload?.current_page || 1,
            per_page: action.payload?.per_page || 10,
            total: action.payload?.total || 0,
            total_pages: action.payload?.total_pages || 1,
          },
        };
      })
      .addCase(listBacklog.rejected, (state, action) => {
        state.getListBacklog = {
          loading: false,
          success: false,
          error: action.payload || 'Failed to fetch data',
          list: [],
          pagination: {
            current_page: 1,
            per_page: 10,
            total: 0,
            total_pages: 1,
          },
        };
      })

      .addCase(getStageNumbers.pending, (state) => {
        state.stageNumbers.loading = true;
        state.stageNumbers.error = null;
      })
      .addCase(getStageNumbers.fulfilled, (state, action) => {
        state.stageNumbers.loading = false;
        state.stageNumbers.data = action.payload.data || [];
      })
      .addCase(getStageNumbers.rejected, (state, action) => {
        state.stageNumbers.loading = false;
        state.stageNumbers.error = action.payload || 'Failed to fetch stage numbers';
      })

      // CR POSITION DETAILS LIST

      .addCase(listCrPositionDetails.pending, (state) => {
        state.crPositionDetailsList.loading = true;
        state.crPositionDetailsList.error = null;
        state.crPositionDetailsList.success = false;
      })
      .addCase(listCrPositionDetails.fulfilled, (state, action) => {
        state.crPositionDetailsList.loading = false;
        state.crPositionDetailsList.success = true;
        state.crPositionDetailsList.data = action.payload;
        state.crPositionDetailsList.error = null;
      })
      .addCase(listCrPositionDetails.rejected, (state, action) => {
        state.crPositionDetailsList.loading = false;
        state.crPositionDetailsList.success = false;
        state.crPositionDetailsList.error = action.payload || 'Failed to fetch cr position list';
        state.dailyDiscrPositionDetailsListpatchList.data = [];
      })

      // ============================================
      // STORE CR POSITION DETAILS
      // ============================================
      .addCase(storeCrPositionDetails.pending, (state) => {
        state.storeCrPositionDetails.loading = true;
        state.storeCrPositionDetails.error = null;
        state.storeCrPositionDetails.success = false;
      })
      .addCase(storeCrPositionDetails.fulfilled, (state, action) => {
        state.storeCrPositionDetails.loading = false;
        state.storeCrPositionDetails.success = true;
        state.storeCrPositionDetails.data = action.payload;
        state.storeCrPositionDetails.error = null;
      })
      .addCase(storeCrPositionDetails.rejected, (state, action) => {
        state.storeCrPositionDetails.loading = false;
        state.storeCrPositionDetails.success = false;
        state.storeCrPositionDetails.error = action.payload || 'Failed to save cr position report';
        state.storeCrPositionDetails.data = [];
      })

      .addCase(getListDefectManagement.pending, (state) => {
        state.getListDefectMngmnt.loading = true;
        state.getListDefectMngmnt.error = null;
      })
      .addCase(getListDefectManagement.fulfilled, (state, action) => {
        state.getListDefectMngmnt.loading = false;
        state.getListDefectMngmnt.data = action.payload.data || [];
      })
      .addCase(getListDefectManagement.rejected, (state, action) => {
        state.getListDefectMngmnt.loading = false;
        state.getListDefectMngmnt.error = action.payload || 'Failed to fetch list';
      })
      .addCase(getStaticLoadDefectTest.pending, (state) => {
        state.getStaticLoadDft.loading = true;
        state.getStaticLoadDft.error = null;
      })
      .addCase(getStaticLoadDefectTest.fulfilled, (state, action) => {
        state.getStaticLoadDft.loading = false;
        state.getStaticLoadDft.data = action.payload.data || [];
      })
      .addCase(getStaticLoadDefectTest.rejected, (state, action) => {
        state.getStaticLoadDft.loading = false;
        state.getStaticLoadDft.error = action.payload || 'Failed to fetch stage numbers';
      })
      .addCase(getShopsList.pending, (state) => {
        state.shops_list.loading = true;
        state.shops_list.error = null;
      })
      .addCase(getShopsList.fulfilled, (state, action) => {
        state.shops_list.loading = false;
        state.shops_list.data = action.payload.data || [];
      })
      .addCase(getShopsList.rejected, (state, action) => {
        state.shops_list.loading = false;
        state.shops_list.error = action.payload || 'Failed to fetch stage numbers';
      })
      .addCase(getFormStageList.pending, (state) => {
        state.form_stage_list.loading = true;
        state.form_stage_list.error = null;
      })
      .addCase(getFormStageList.fulfilled, (state, action) => {
        state.form_stage_list.loading = false;
        state.form_stage_list.data = action.payload.data || [];
      })
      .addCase(getFormStageList.rejected, (state, action) => {
        state.form_stage_list.loading = false;
        state.form_stage_list.error = action.payload || 'Failed to fetch stage numbers';
      })
      .addCase(fetchVersion.pending, (state) => {
        state.versionList.loading = true;
        state.versionList.error = null;
      })
      .addCase(fetchVersion.fulfilled, (state, action) => {
        state.versionList.loading = false;
        state.versionList.data = action.payload.data || [];
      })
      .addCase(fetchVersion.rejected, (state, action) => {
        state.versionList.loading = false;
        state.versionList.error = action.payload || 'Failed to fetch data';
      })
      .addCase(fetchShellNumbersForFilter.pending, (state) => {
        state.allShellNo.loading = true;
        state.allShellNo.error = null;
      })
      .addCase(fetchShellNumbersForFilter.fulfilled, (state, action) => {
        state.allShellNo.loading = false;
        state.allShellNo.data = action.payload.data || [];
      })
      .addCase(fetchShellNumbersForFilter.rejected, (state, action) => {
        state.allShellNo.loading = false;
        state.allShellNo.error = action.payload || 'Failed to fetch data';
      })
      .addCase(fetchNotifications.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchNotifications.fulfilled, (state, action) => {
        state.loading = false;
        state.notificationData.data = action.payload;
      })
      .addCase(fetchNotifications.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || 'Failed to fetch train types';
      })
      .addCase(fetchSingleNotification.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchSingleNotification.fulfilled, (state, action) => {
        state.loading = false;
        state.selectedNotification.data = action.payload;
      })
      .addCase(fetchSingleNotification.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || 'Failed to fetch train types';
      });
  },
});

export const {
  clearMaterialError,
  clearSuccessMessage,
  clearComponentMessages,
  clearAddOperationState,
  clearAddDrgState,
  clearDrgMessages,
  clearRoofDimensionDetail,
  clearAddRoofDimensionState,
  clearUpdateRoofDimensionState,
  clearDeleteRoofDimensionState,
  resetRoofDimensionStates,
  clearSelected
} = materialSlice.actions;

export default materialSlice.reducer;
